import Swiper from 'swiper/js/swiper.js';

class SingleProduct{
    constructor(){
        this.gallery = document.querySelector('.product-single__images');


        if(this.gallery) this.swiperGallery(this.gallery);
    }

    swiperGallery(el){
        let slider = new Swiper(el.querySelector('.mySwiper'), {
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
                renderBullet: function (index, className) {
                    let item = el.querySelectorAll('.swiper-slide')[index].querySelector('img').src;
                    return `<span class="${className}">
                        <img src="${item}" alt="pagination-${++index}">
                    </span>`;
                }
            }
        });
    }
}

export default SingleProduct;